import $ from 'jquery'
import TridentShooter from './TridentShooter'
import AnimateScroller from './AnimateScroller'

const scroller = new AnimateScroller(
  $('html, body'),
  {
    $container: $('body'),
    offset: 50,
    duration: 400,
    easing: 'swing'
  }
)

function InputFileImage (node, callbackOnSuccess, callbackOnAlert = null) {
  this.$node = null
  this.$image = null
  this.$trident = null
  this.defaultsrc = ''
  this.maxfilesize = 0
  this.callbackOnSuccess = callbackOnSuccess
  this.showAlert = callbackOnAlert || window.alert
  this.init(node)
}
InputFileImage.prototype.init = function (node) {
  this.initNode(node)
  this.initEvents()
}
InputFileImage.prototype.initNode = function (node) {
  this.$node = $(node)
  this.$node.data('InputFileImage', this)
  this.$image = $('<img>').addClass('thumbnail').hide()
  this.$node.after(this.$image)

  if (!this.$image.data('TridentShooter')) {
    this.$trident = new TridentShooter(this.$image)
  }

  this.defaultsrc = this.$node.attr('src') || this.defaultsrc

  if (this.defaultsrc) {
    if (this.$node.attr('required')) {
      this.$node.removeAttr('required')
    }

    this.show()
  }

  let filesize = 0
  const maxfilesize = this.$node.attr('data-maxfilesize')
  if (maxfilesize) {
    const unit = (maxfilesize.match(/([a-zA-Z]+)$/) || ['', 'b'])[1].toUpperCase()
    const size = parseInt((maxfilesize.match(/^(\d+)/) || ['', '0'])[1], 10)
    filesize = size
    switch (unit) {
      case 'KB':
        filesize *= 1024
        break
      case 'MB':
        filesize *= 1024 * 1024
        break
      case 'GB':
        filesize *= 1024 * 1024 * 1024
        break
      case 'TB':
        filesize *= 1024 * 1024 * 1024 * 1024
        break
    }
  }
  this.maxfilesize = filesize
}
InputFileImage.prototype.initEvents = function () {
  this.$node
    .on('change', $.proxy(this.onChange, this))
    .on('invalid', $.proxy(this.onInvalid, this))

  this.$node.closest('label')
    .on('click', $.proxy(this.onClick, this))

  $(window)
    .on('load.inputFileImage', $.proxy(this.onWindowLoad, this))
}
InputFileImage.prototype.clear = function () {
  if (this.defaultsrc) {
    this.show()
  } else {
    this.$image.attr('src', '')
    this.$image.hide()
    this.$node.closest('label').removeClass('file-selected')
  }
}
InputFileImage.prototype.show = function (src) {
  this.$image
    .attr('src', src || this.defaultsrc)
    .show()

  this.$node.closest('label').addClass('file-selected')
}
InputFileImage.prototype.load = function (file) {
  if (this.reader) {
    if (this.reader.readyState) {
      try {
        this.reader.abort()
      } catch (err) {
      }
    }
    this.reader = null
  }

  if (file && file.type.indexOf('image/') === 0) {
    this.reader = new FileReader()
    $(this.reader).on('load', $.proxy(this.onLoad, this))
    this.reader.readAsDataURL(file)
  } else {
    this.clear()
  }
}
InputFileImage.prototype.checkFileExist = function (file) {
  return file && file.size
}
InputFileImage.prototype.checkRequired = function (file) {
  return !this.$node.attr('required') || this.checkFileExist(file)
}
InputFileImage.prototype.checkFileSize = function (file) {
  return !file || !this.maxfilesize || (file.size <= this.maxfilesize)
}
InputFileImage.prototype.checkFileType = function (file) {
  let accepts = this.$node.attr('accept')

  if (!file || !accepts.length) {
    return true
  }

  const type = file.type.toLowerCase()
  accepts = accepts.replace(/\s/g, '').toLowerCase().split(/,/g)

  for (let i = 0, n = accepts.length; i < n; i++) {
    let accept = accepts[i]
    if (accept.indexOf('.') === 0) {
      accept = accept.replace(/^\./, 'image/')
    }

    let _type = type
    if (accept.match(/\/\*$/)) {
      accept = accept.replace(/\/.*?$/, '')
      _type = _type.replace(/\/.*?$/, '')
    }

    if (accept === _type) {
      return true
    }
  }
  return false
}
InputFileImage.prototype.check = function (file) {
  const _file = file || this.$node.get(0).files[0] || null

  const required = this.checkRequired(_file)
  const filesize = this.checkFileSize(_file)
  const filetype = this.checkFileType(_file)

  return {
    valid: !!(this.$node.prop('disabled') || (required && filesize && filetype)),
    required,
    filesize,
    filetype
  }
}
InputFileImage.prototype.getErrorMessage = function (type) {
  return this.$node.attr('data-error-' + type)
}
InputFileImage.prototype.alert = function (message) {
  this.showAlert(message)
}
InputFileImage.prototype.onChange = function (e) {
  const file = e.target.files ? e.target.files[0] : null
  const result = this.check(file)
  if (!file || result.valid) {
    this.load(file)
    this.callbackOnSuccess(this.$node.attr('id'))
  } else if (!result.valid) {
    if (!this.$node.prop('disabled')) {
      e.preventDefault()
      this.$node.val('')

      const messages = ['required', 'filesize', 'filetype']
        .filter(check => !result[check])
        .map(check => this.getErrorMessage(check))

      this.alert(messages.join('\n'))
    }
  }
}
InputFileImage.prototype.onLoad = function (e) {
  this.show(e.target.result)
}
InputFileImage.prototype.showError = function (message, noscroll) {
  const $label = this.$node.closest('label').attr('data-error', message)
  if (!InputFileImage.blocked) {
    if (!noscroll) {
      scroller.scrollToNode($label)
    }

    InputFileImage.blocked = true
    setTimeout(function () {
      InputFileImage.blocked = false
    })
  }
}
InputFileImage.prototype.onInvalid = function (e) {
  const message = e.target.validationMessage
  if (message && TridentShooter.isNeeded()) {
    this.showError(message)
  }
}
InputFileImage.prototype.onClick = function (e) {
  e.target.value = ''
  this.clear()
  this.$node.closest('label').removeAttr('data-error')
}
InputFileImage.prototype.onWindowLoad = function () {
  if (this.$node) {
    this.$node.trigger('change')
  }
}
/**
 * HTMLInputElement に設定されているファイルを取得する
 * @param onInvalidThrowError 必須項目でファイルが未設定の場合、エラーを投げる
 */
InputFileImage.prototype.getFile = function (onInvalidThrowError = true) {
  if (this.$node && this.$node.get(0).files.length) {
    return this.$node.get(0).files[0]
  }
  if (this.$node.attr('required') && onInvalidThrowError) {
    throw new Error(this.$node.get(0).id + ' is missing')
  }
  return ''
}

/**
 * イベントのクリアと nodeの参照のクリア
 */
InputFileImage.prototype.destroy = function () {
  this.$node.closest('label').off()
  this.$node.off()
  $(window).off('load.inputFileImage')
  if (this.$trident) {
    this.$trident.destroy()
    this.$trident = null
  }
  this.$image = null
  this.$node = null
}

export default InputFileImage
